import { CustomComponentTypes } from '@ben/shared/constants';
import ModularAmountInput from '../modular-components/modular-amount-input/modular-amount-input';
import ModularBeneficiariesInput from '../modular-components/modular-beneficiaries-input/modular-beneficiaries-input';
import ModularBuyAndSellHolidayInput from '../modular-components/modular-buy-and-sell-holiday-input/modular-buy-and-sell-holiday-input';
import ModularCalculatedValueInput from '../modular-components/modular-calculated-value-input/modular-calculated-value-input';
import ModularCheckboxInput from '../modular-components/modular-checkbox-input/modular-checkbox-input';
import ModularContactsInput from '../modular-components/modular-contacts-input/modular-contacts-input';
import ModularDateInput from '../modular-components/modular-date-input/modular-date-input';
import ModularDropdownInput from '../modular-components/modular-dropdown-input/modular-dropdown-input';
import ModularFileUploadInput from '../modular-components/modular-file-upload-input/modular-file-upload-input';
import ModularMultiSelectInput from '../modular-components/modular-multi-select-input/modular-multi-select-input';
import ModularPensionSlidersInput from '../modular-components/modular-pension-slider-input/modular-pension-slider-input';
import ModularSliderInput from '../modular-components/modular-slider-input/modular-slider-input';
import ModularTextBlockInput from '../modular-components/modular-text-block-input/modular-text-block-input';
import ModularTextInput from '../modular-components/modular-text-input/modular-text-input';

const modularStepChildComponent = (
  type: CustomComponentTypes,
  componentControllerName: string
) => {
  switch (type) {
    case CustomComponentTypes.TEXT_INPUT: {
      return (
        <ModularTextInput componentControllerName={componentControllerName} />
      );
    }
    case CustomComponentTypes.AMOUNT_INPUT: {
      return (
        <ModularAmountInput componentControllerName={componentControllerName} />
      );
    }
    case CustomComponentTypes.CHECKBOX: {
      return (
        <ModularCheckboxInput
          componentControllerName={componentControllerName}
        />
      );
    }
    case CustomComponentTypes.TEXT_BLOCK: {
      return (
        <ModularTextBlockInput
          componentControllerName={componentControllerName}
        />
      );
    }
    case CustomComponentTypes.DATE_INPUT: {
      return (
        <ModularDateInput componentControllerName={componentControllerName} />
      );
    }
    case CustomComponentTypes.FILE_UPLOAD: {
      return (
        <ModularFileUploadInput
          componentControllerName={componentControllerName}
        />
      );
    }
    case CustomComponentTypes.DROPDOWN: {
      return (
        <ModularDropdownInput
          componentControllerName={componentControllerName}
        />
      );
    }
    case CustomComponentTypes.MULTI_SELECT: {
      return (
        <ModularMultiSelectInput
          componentControllerName={componentControllerName}
        />
      );
    }
    case CustomComponentTypes.MULTI_SELECT_WITH_SUBFORM: {
      return (
        <ModularMultiSelectInput
          componentControllerName={componentControllerName}
          hasSubform
        />
      );
    }
    case CustomComponentTypes.PENSION_SLIDERS: {
      return (
        <ModularPensionSlidersInput
          componentControllerName={componentControllerName}
        />
      );
    }
    case CustomComponentTypes.BUY_SELL_HOLIDAY: {
      return (
        <ModularBuyAndSellHolidayInput
          componentControllerName={componentControllerName}
        />
      );
    }
    case CustomComponentTypes.SLIDER: {
      return (
        <ModularSliderInput componentControllerName={componentControllerName} />
      );
    }
    case CustomComponentTypes.CALCULATED_VALUE: {
      return (
        <ModularCalculatedValueInput
          componentControllerName={componentControllerName}
        />
      );
    }
    case CustomComponentTypes.BENEFICIARIES: {
      return (
        <ModularBeneficiariesInput
          componentControllerName={componentControllerName}
        />
      );
    }
    case CustomComponentTypes.CONTACTS: {
      return (
        <ModularContactsInput
          componentControllerName={componentControllerName}
        />
      );
    }
    default: {
      return;
    }
  }
};

export default modularStepChildComponent;
